<template>
    <!-- 免费次数已用完弹窗 start -->
    <div class="" v-if="islogin && subParam.is_subscribe == 1 && subParam.is_have_view_auth == 2 && subParam.is_month_chance == 2">
        <div class="no_vips">
            <div class="no_vip_title"> 您本月的免费浏览次数剩余一次，是否使用</div>
            <div class="no_vip_wrap">
                <div class="no_vip_tips">
                    <div>NEJM 医学前沿</div>
                    <div>使用权益可继续浏览</div>
                </div>
                <div class="no_vip_line"></div>
                <div class="open_vip" @click="useFree()">
                    立即使用
                </div>
            </div>
        </div>
    </div>
    <!-- 免费次数已用完弹窗 end -->
</template>
<script>
// import {
//     useFreeRead
// } from '@/api/article'
// import merge from 'webpack-merge'
import axios from 'axios'
export default {
    name: 'FreeReadPopup',
    data() {
        return {
            userInfo: {
                truename: "张学友"
            }
        }
    },
    props: {
        subParam:{
            type: Object,
            default: () => ({}),
        },
        islogin: {
            type: Boolean,
            default: false,
        },
        isFree: {
            type: Boolean,
            default: true,
        },
        is_subscribe: {
            type: Number,
            default: 1
        },
        is_have_view_auth: {
            type: Number,
            default: 2
        },
        is_month_chance: {
            type: Number,
            default: 1
        },
    },
    mounted() {
        console.log('没有使用次数弹窗')
    },
    methods: {
        close() {
            this.$emit('noclose', false)
        },
        openVip(){
            // this.$router
            // .push({
            //     query: merge(this.$route.query, { type: 'flag4' }),
            // })
            this.$router.push({ path:'/personal', query:{ type: 'flag4',herfUrl:window.location.href } })
            .catch((err) => {
                console.log('输出报错', err)
            })
        },
        useFree(){
            let token = window.sessionStorage.getItem('token');
            console.log(token,'token');    
            axios.get('https://www.nejmqianyan.cn/index.php?c=program&m=articleUseMonthChance&id='+this.subParam.articleId + '&sf='+'pc'+'&token='+ token).then(res => {
                console.log(res);
                if(res.data.result == '1'){
                    this.$message.success('使用成功')
                    this.$emit('noclose', false)
                    this.$emit('content',res.data.article_content)
                    this.$emit('showContent',true)
                    // this.$emit('getArticle')
                    return
                }
                // this.$emit('getArticle')
                this.$message.error(res.data.msg || '您本月免费次数已经使用了!' )
            })
        }
    },

}
</script>
<style lang="less" scoped>
/**
 * 没有会员
 */
 .no_vips{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
 }
.body_novip{
    // height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #fff;
    opacity: 0.85;

}
.NoFree_cont {
    position: fixed;
}

.no_vip {
    width: 100%;
    /* height: 279px; */
    /** 底部小块白色*/
    // height: 100%;
    /** 整个页面白色*/
    height: 215px;
    background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.53) 1%, #FFFFFF 40%, #FFFFFF 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    z-index: 9999;
    gap: 20px;
    left: 0;
    flex-direction: column;
}

.no_vip_title {
    font-family: PingFangSC-Semibold;
    font-size: 24px;
    color: #000;
    text-align: center;
    font-weight: bold;
    display: block;
    margin-bottom: 20px;
}

.no_vip_wrap {
    display: flex;
    align-items: center;
    gap: 28px;
}

.no_vip_tips {
    display: flex;
    gap: 6px;
    flex-direction: column;
}

.no_vip_tips div {
    font-family: PingFangSC-Regular;
    font-size: 20px;
    color: #E52E00;
    font-weight: 400;
}

.no_vip_line {
    width: 4px;
    height: 56px;
    background: #E52E00;
}

.open_vip {
    padding: 11px 80px;
    background: #E52E00;
    border-radius: 28px;
    color: #fff;
    font-family: PingFangSC-Medium;
    font-size: 20px;
    font-weight: 500;
    cursor: pointer;
}

// 移动端样式
.mobile {
    .no_vip {
        width: 100%;
        // /* height: 279rpx; */
        /** 底部小块白色*/
        // height: 100%;
        height: 300px;
        /** 整个页面白色*/
        background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.53) 1%, #FFFFFF 40%, #FFFFFF 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        bottom: 0;
        z-index: 9999;
        gap: 20px;
        flex-direction: column;
    }

    .no_vip_title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #000;
        text-align: center;
        font-weight: bold;
        display: block;
    }

    .no_vip_wrap {
        display: flex;
        align-items: center;
        gap: 28px;
    }

    .no_vip_tips {
        display: flex;
        gap: 6px;
        flex-direction: column;
    }

    .no_vip_tips div {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #E52E00;
        font-weight: 400;
    }

    .no_vip_line {
        width: 2px;
        height: 50px;
        background: #E52E00;
    }

    .open_vip {
        padding: 12px 50px;
        background: #E52E00;
        border-radius: 28px;
        color: #fff;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        font-weight: 500;
        cursor: pointer;
    }
}
</style>
  